var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"font-bold py-2 text-2xl md:text-4xl font-display capitalize mb-1",class:[_vm.color]},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }